import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
export const ApprovalWorkflowDialogWrapper = styled(Dialog)`
height:100%;
.confirmationButtonBox{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.confirmationTextForVis{
  display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    padding-bottom: 0px;
}
.customDialogTitle {
    
    background-color: #1b4a83;
    text-align: center;
    color: #fff;
         }
         .customDialog
         {
            text-align: center;
            color:#000;
            img{
               display: block;
               margin: 10px auto; /* Center the image horizontally */
               max-width: 100px; /* Set the desired max width for the image */
           }
           .note
           {
            width:70%;
            text-align: left;
            font-weight:700;
            padding-left: 20px;
           }
           .confirmationText{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
           }
           .confirmationButton{
            display: flex;
            justify-content: center;
            padding-bottom: 30px;
           }
          .customDropdown
          { text-align: left;
            width:100%;
            padding-top:10px;
          }
          .errorBox
          {
            text-align: left;
          }
          span.error {
            
            color: #d32f2f;
            font-size:12px;
            line-height: 2;
            font-weight: 400;
        }
        span.red {
            color: #ff0000;
        }
        .errorInput {
            border: 1px solid #ff0000;
            border-radius: 5px;
        
        
          }
          .inputform
          {
            width:100%;
            padding-top:10px;
            .formValue{ width:100%;}
          }
         }
         .dialogbutton
         {
          text-align:center;
          display:block;
          margin-bottom: 10px;

         .confirmButton{
          text-align:center;
            background-color: #1b4a83;
            width:25%;
         }
         .rightButton {
          text-align:center;
          color:#1b4a83;
           width:25%;
           border-color: #1b4a83;
          }
        }
     
`;

